export default "__VITE_ASSET__CT0JTr1t__"